import { ElementPlaceEnum, ElementTypeEnum } from '~shared/constants/element-type.enum';
import { environment } from '~env/environment';
import { COUNTRY_BASED_MARKET_NAME, MarketName } from './country-code.enum';
import { getCountryDomainCode } from '~server/utils/country-detection.util';

export const SCRIPT_TYPE = 'text/javascript';
export const ICON_TYPE = 'image/png';
export const STYLE_TYPE = 'stylesheet';

export const appleTouchIcon = 'apple-touch-icon';

export const cdnPath = () => environment.cdnBaseUrl();
export const akamaiPath = () => environment.akamaiBaseUrl();

const favicons = () => {
  const marketName = COUNTRY_BASED_MARKET_NAME[getCountryDomainCode()];
  const faviconPrefix: string = marketName === MarketName.Makro ? `${MarketName.Makro}-` : '';
  return [
    {
      element: ElementTypeEnum.LINK,
      place: ElementPlaceEnum.HEAD,
      attributes: [
        { name: 'rel', value: 'icon' },
        { name: 'type', value: ICON_TYPE },
        { name: 'href', value: `${cdnPath()}/images/favicons/${faviconPrefix}favicon-16x16.png` },
        { name: 'sizes', value: '16x16' },
      ],
    },
    {
      element: ElementTypeEnum.LINK,
      place: ElementPlaceEnum.HEAD,
      attributes: [
        { name: 'rel', value: 'icon' },
        { name: 'type', value: ICON_TYPE },
        { name: 'href', value: `${cdnPath()}/images/favicons/${faviconPrefix}favicon-32x32.png` },
        { name: 'sizes', value: '32x32' },
      ],
    },
    {
      element: ElementTypeEnum.LINK,
      place: ElementPlaceEnum.HEAD,
      attributes: [
        { name: 'rel', value: 'icon' },
        { name: 'type', value: 'image/png' },
        { name: 'href', value: `${cdnPath()}/images/favicons/${faviconPrefix}favicon-96x96.png` },
        { name: 'sizes', value: '96x96' },
      ],
    },
  ];
};

const icons = () => {
  const marketName = COUNTRY_BASED_MARKET_NAME[getCountryDomainCode()];
  return [
    {
      element: ElementTypeEnum.LINK,
      place: ElementPlaceEnum.HEAD,
      attributes: [
        { name: 'rel', value: appleTouchIcon },
        { name: 'href', value: `${cdnPath()}/images/apple-touch-icons/${marketName}/touch-icon-iphone.png` },
      ],
    },
    {
      element: ElementTypeEnum.LINK,
      place: ElementPlaceEnum.HEAD,
      attributes: [
        { name: 'rel', value: appleTouchIcon },
        { name: 'href', value: `${cdnPath()}/images/apple-touch-icons/${marketName}/touch-icon-ipad.png` },
        { name: 'sizes', value: '72x72' },
      ],
    },
    {
      element: ElementTypeEnum.LINK,
      place: ElementPlaceEnum.HEAD,
      attributes: [
        { name: 'rel', value: appleTouchIcon },
        { name: 'href', value: `${cdnPath()}/images/apple-touch-icons/${marketName}/touch-icon-iphone-retina.png` },
        { name: 'sizes', value: '114x114' },
      ],
    },
    {
      element: ElementTypeEnum.LINK,
      place: ElementPlaceEnum.HEAD,
      attributes: [
        { name: 'rel', value: appleTouchIcon },
        { name: 'href', value: `${cdnPath()}/images/apple-touch-icons/${marketName}/touch-icon-ipad-retina.png` },
        { name: 'sizes', value: '144x144' },
      ],
    },
  ];
};

const scripts = () => [
  {
    element: ElementTypeEnum.SCRIPT,
    place: ElementPlaceEnum.HEAD,
    attributes: [
      { name: 'src', value: `${cdnPath()}/scripts/modernizr/modernizr.min.js` },
      { name: 'type', value: SCRIPT_TYPE },
    ],
  },
];

const styles = [];

//@ts-ignore
export const SOURCES_CONFIG = () => [...favicons(), ...icons(), ...scripts(), ...styles];
